module.exports = __webpack_public_path__ + "img/minus-circle-disabled.984b50ce.svg";